// English help translations
import accountManagementEn from './accountManagement/en.json'
import adminAccessEn from './adminAccess/en.json'
import antiSpamEn from './antiSpam/en.json'
import apiAccessEn from './apiAccess/en.json'
import atpExemptEn from './atpExempt/en.json'
import atpLogEn from './atpLog/en.json'
import auditLogEn from './auditLog/en.json'
import complianceEn from './compliance/en.json'
import configureMxRecordsEn from './configureMxRecords/en.json'
import customBrandingEn from './customBranding/en.json'
import directoryServicesEn from './directoryServices/en.json'
import disclaimerEn from './disclaimer/en.json'
import dkimSigningEn from './dkimSigning/en.json'
import dnsSettingsEn from './dnsSettings/en.json'
import domainManagerEn from './domainManager/en.json'
import domainMigrationEn from './domainMigration/en.json'
import domainSettingsEn from './domainSettings/en.json'
import domainVerificationEn from './domainVerification/en.json'
import emailConfirmationEn from './emailConfirmation/en.json'
import emailContinuityEn from './emailContinuity/en.json'
import emailEncryptionEn from './emailEncryption/en.json'
import endUserLogEn from './endUserLog/en.json'
import endUserQuarantineNotificationEn from './endUserQuarantineNotification/en.json'
import endUserSenderPolicyEn from './endUserSenderPolicy/en.json'
import exemptRecipientsEn from './exemptRecipients/en.json'
import forensicDataEn from './forensicData/en.json'
import impersonationProtectionEn from './impersonationProtection/en.json'
import inboundAntiPhishingEn from './inboundAntiPhishing/en.json'
import inboundAntiVirusEn from './inboundAntiVirus/en.json'
import inboundAtpEn from './inboundAtp/en.json'
import inboundAttachmentFilterEn from './inboundAttachmentFilter/en.json'
import inboundBulkMailEn from './inboundBulkMail/en.json'
import inboundContentPoliciesEn from './inboundContentPolicies/en.json'
import inboundCustomRblsEn from './inboundCustomRbls/en.json'
import inboundEmailBannersEn from './inboundEmailBanners/en.json'
import inboundIntentDomainEn from './inboundIntentDomain/en.json'
import inboundIpAddressPoliciesEn from './inboundIpAddressPolicies/en.json'
import inboundMachineLearningEn from './inboundMachineLearning/en.json'
import inboundMessageContentFilterEn from './inboundMessageContentFilter/en.json'
import inboundRateControlEn from './inboundRateControl/en.json'
import inboundRecipientPoliciesEn from './inboundRecipientPolicies/en.json'
import inboundRegionalPoliciesEn from './inboundRegionalPolicies/en.json'
import inboundSenderAuthenticationEn from './inboundSenderAuthentication/en.json'
import inboundSenderPoliciesEn from './inboundSenderPolicies/en.json'
import inboundSenderPolicyEn from './inboundSenderPolicy/en.json'
import inboundSpamScoringEn from './inboundSpamScoring/en.json'
import incidentResponseEn from './incidentResponse/en.json'
import linkedAccountsEn from './linkedAccounts/en.json'
import linkProtectionEn from './linkProtection/en.json'
import logEn from './log/en.json'
import mailServerTestEn from './mailServerTest/en.json'
import outboundAntiVirusEn from './outboundAntiVirus/en.json'
import outboundAttachmentFilterEn from './outboundAttachmentFilter/en.json'
import outboundContentPoliciesEn from './outboundContentPolicies/en.json'
import outboundDlpEn from './outboundDlp/en.json'
import outboundEncryptionEn from './outboundEncryption/en.json'
import outboundIpAddressPoliciesEn from './outboundIpAddressPolicies/en.json'
import outboundMessageContentFilterEn from './outboundMessageContentFilter/en.json'
import outboundPredefinedFiltersEn from './outboundPredefinedFilters/en.json'
import outboundQuarantineInboxEn from './outboundQuarantineInbox/en.json'
import outboundRateControlEn from './outboundRateControl/en.json'
import outboundRecipientPolicyEn from './outboundRecipientPolicy/en.json'
import outboundSenderIpEn from './outboundSenderIp/en.json'
import outboundSenderIpRangesEn from './outboundSenderIpRanges/en.json'
import outboundSenderPolicyEn from './outboundSenderPolicy/en.json'
import outboundTaggingEn from './outboundTagging/en.json'
import outboundTaglineEn from './outboundTagline/en.json'
import quarantineEn from './quarantine/en.json'
import quarantineNotificationEn from './quarantineNotification/en.json'
import recipientListEn from './recipientList/en.json'
import recipientVerificationEn from './recipientVerification/en.json'
import regexEn from './regex/en.json'
import reportsAllDomainsEn from './reportsAllDomains/en.json'
import reportsDomainEn from './reportsDomain/en.json'
import scheduledReportsEn from './scheduledReports/en.json'
import securityAwarenessTrainingEn from './securityAwarenessTraining/en.json'
import selfService1En from './selfService1/en.json'
import selfService2En from './selfService2/en.json'
import selfService3En from './selfService3/en.json'
import selfService4En from './selfService4/en.json'
import selfService5En from './selfService5/en.json'
import senderAuthenticationEn from './senderAuthentication/en.json'
import senderNotificationEn from './senderNotification/en.json'
import senderPolicyEn from './senderPolicy/en.json'
import siemEn from './siem/en.json'
import statusEn from './status/en.json'
import statusSeenRecipientsEn from './statusSeenRecipients/en.json'
import syslogIntegrationEn from './syslogIntegration/en.json'
import systemNotificationsEn from './systemNotifications/en.json'
import usersAllowListEn from './usersAllowList/en.json'
import usersBlockListEn from './usersBlockList/en.json'
import usersDefaultPolicyEn from './usersDefaultPolicy/en.json'
import usersEditEn from './usersEdit/en.json'
import usersEmailContinuityEn from './usersEmailContinuity/en.json'
import usersListEn from './usersList/en.json'
import usersQuarantineEn from './usersQuarantine/en.json'

// Japanese help translations
import accountManagementJa from './accountManagement/ja.json'
import adminAccessJa from './adminAccess/ja.json'
import antiSpamJa from './antiSpam/ja.json'
import apiAccessJa from './apiAccess/ja.json'
import atpExemptJa from './atpExempt/ja.json'
import atpLogJa from './atpLog/ja.json'
import auditLogJa from './auditLog/ja.json'
import complianceJa from './compliance/ja.json'
import configureMxRecordsJa from './configureMxRecords/ja.json'
import customBrandingJa from './customBranding/ja.json'
import directoryServicesJa from './directoryServices/ja.json'
import disclaimerJa from './disclaimer/ja.json'
import dkimSigningJa from './dkimSigning/ja.json'
import dnsSettingsJa from './dnsSettings/ja.json'
import domainManagerJa from './domainManager/ja.json'
import domainMigrationJa from './domainMigration/ja.json'
import domainSettingsJa from './domainSettings/ja.json'
import domainVerificationJa from './domainVerification/ja.json'
import emailConfirmationJa from './emailConfirmation/ja.json'
import emailContinuityJa from './emailContinuity/ja.json'
import emailEncryptionJa from './emailEncryption/ja.json'
import endUserLogJa from './endUserLog/ja.json'
import endUserQuarantineNotificationJa from './endUserQuarantineNotification/ja.json'
import endUserSenderPolicyJa from './endUserSenderPolicy/ja.json'
import exemptRecipientsJa from './exemptRecipients/ja.json'
import forensicDataJa from './forensicData/ja.json'
import impersonationProtectionJa from './impersonationProtection/ja.json'
import inboundAntiPhishingJa from './inboundAntiPhishing/ja.json'
import inboundAntiVirusJa from './inboundAntiVirus/ja.json'
import inboundAtpJa from './inboundAtp/ja.json'
import inboundAttachmentFilterJa from './inboundAttachmentFilter/ja.json'
import inboundBulkMailJa from './inboundBulkMail/ja.json'
import inboundContentPoliciesJa from './inboundContentPolicies/ja.json'
import inboundCustomRblsJa from './inboundCustomRbls/ja.json'
import inboundEmailBannersJa from './inboundEmailBanners/ja.json'
import inboundIntentDomainJa from './inboundIntentDomain/ja.json'
import inboundIpAddressPoliciesJa from './inboundIpAddressPolicies/ja.json'
import inboundMachineLearningJa from './inboundMachineLearning/ja.json'
import inboundMessageContentFilterJa from './inboundMessageContentFilter/ja.json'
import inboundRateControlJa from './inboundRateControl/ja.json'
import inboundRecipientPoliciesJa from './inboundRecipientPolicies/ja.json'
import inboundRegionalPoliciesJa from './inboundRegionalPolicies/ja.json'
import inboundSenderAuthenticationJa from './inboundSenderAuthentication/ja.json'
import inboundSenderPoliciesJa from './inboundSenderPolicies/ja.json'
import inboundSenderPolicyJa from './inboundSenderPolicy/ja.json'
import inboundSpamScoringJa from './inboundSpamScoring/ja.json'
import incidentResponseJa from './incidentResponse/ja.json'
import linkedAccountsJa from './linkedAccounts/ja.json'
import linkProtectionJa from './linkProtection/ja.json'
import logJa from './log/ja.json'
import mailServerTestJa from './mailServerTest/ja.json'
import outboundAntiVirusJa from './outboundAntiVirus/ja.json'
import outboundAttachmentFilterJa from './outboundAttachmentFilter/ja.json'
import outboundContentPoliciesJa from './outboundContentPolicies/ja.json'
import outboundDlpJa from './outboundDlp/ja.json'
import outboundEncryptionJa from './outboundEncryption/ja.json'
import outboundIpAddressPoliciesJa from './outboundIpAddressPolicies/ja.json'
import outboundMessageContentFilterJa from './outboundMessageContentFilter/ja.json'
import outboundPredefinedFiltersJa from './outboundPredefinedFilters/ja.json'
import outboundQuarantineInboxJa from './outboundQuarantineInbox/ja.json'
import outboundRateControlJa from './outboundRateControl/ja.json'
import outboundRecipientPolicyJa from './outboundRecipientPolicy/ja.json'
import outboundSenderIpJa from './outboundSenderIp/ja.json'
import outboundSenderIpRangesJa from './outboundSenderIpRanges/ja.json'
import outboundSenderPolicyJa from './outboundSenderPolicy/ja.json'
import outboundTaggingJa from './outboundTagging/ja.json'
import outboundTaglineJa from './outboundTagline/ja.json'
import quarantineJa from './quarantine/ja.json'
import quarantineNotificationJa from './quarantineNotification/ja.json'
import recipientListJa from './recipientList/ja.json'
import recipientVerificationJa from './recipientVerification/ja.json'
import regexJa from './regex/ja.json'
import reportsAllDomainsJa from './reportsAllDomains/ja.json'
import reportsDomainJa from './reportsDomain/ja.json'
import scheduledReportsJa from './scheduledReports/ja.json'
import securityAwarenessTrainingJa from './securityAwarenessTraining/ja.json'
import selfService1Ja from './selfService1/ja.json'
import selfService2Ja from './selfService2/ja.json'
import selfService3Ja from './selfService3/ja.json'
import selfService4Ja from './selfService4/ja.json'
import selfService5Ja from './selfService5/ja.json'
import senderAuthenticationJa from './senderAuthentication/ja.json'
import senderNotificationJa from './senderNotification/ja.json'
import senderPolicyJa from './senderPolicy/ja.json'
import siemJa from './siem/ja.json'
import statusJa from './status/ja.json'
import statusSeenRecipientsJa from './statusSeenRecipients/ja.json'
import syslogIntegrationJa from './syslogIntegration/ja.json'
import systemNotificationsJa from './systemNotifications/ja.json'
import usersAllowListJa from './usersAllowList/ja.json'
import usersBlockListJa from './usersBlockList/ja.json'
import usersDefaultPolicyJa from './usersDefaultPolicy/ja.json'
import usersEditJa from './usersEdit/ja.json'
import usersEmailContinuityJa from './usersEmailContinuity/ja.json'
import usersListJa from './usersList/ja.json'
import usersQuarantineJa from './usersQuarantine/ja.json'

// Spanish help translations
import accountManagementEs from './accountManagement/es.json'
import adminAccessEs from './adminAccess/es.json'
import antiSpamEs from './antiSpam/es.json'
import apiAccessEs from './apiAccess/es.json'
import atpExemptEs from './atpExempt/es.json'
import atpLogEs from './atpLog/es.json'
import auditLogEs from './auditLog/es.json'
import complianceEs from './compliance/es.json'
import configureMxRecordsEs from './configureMxRecords/es.json'
import customBrandingEs from './customBranding/es.json'
import directoryServicesEs from './directoryServices/es.json'
import disclaimerEs from './disclaimer/es.json'
import dkimSigningEs from './dkimSigning/es.json'
import dnsSettingsEs from './dnsSettings/es.json'
import domainManagerEs from './domainManager/es.json'
import domainMigrationEs from './domainMigration/es.json'
import domainSettingsEs from './domainSettings/es.json'
import domainVerificationEs from './domainVerification/es.json'
import emailConfirmationEs from './emailConfirmation/es.json'
import emailContinuityEs from './emailContinuity/es.json'
import emailEncryptionEs from './emailEncryption/es.json'
import endUserLogEs from './endUserLog/es.json'
import endUserQuarantineNotificationEs from './endUserQuarantineNotification/es.json'
import endUserSenderPolicyEs from './endUserSenderPolicy/es.json'
import exemptRecipientsEs from './exemptRecipients/es.json'
import forensicDataEs from './forensicData/es.json'
import impersonationProtectionEs from './impersonationProtection/es.json'
import inboundAntiPhishingEs from './inboundAntiPhishing/es.json'
import inboundAntiVirusEs from './inboundAntiVirus/es.json'
import inboundAtpEs from './inboundAtp/es.json'
import inboundAttachmentFilterEs from './inboundAttachmentFilter/es.json'
import inboundBulkMailEs from './inboundBulkMail/es.json'
import inboundContentPoliciesEs from './inboundContentPolicies/es.json'
import inboundCustomRblsEs from './inboundCustomRbls/es.json'
import inboundEmailBannersEs from './inboundEmailBanners/es.json'
import inboundIntentDomainEs from './inboundIntentDomain/es.json'
import inboundIpAddressPoliciesEs from './inboundIpAddressPolicies/es.json'
import inboundMachineLearningEs from './inboundMachineLearning/es.json'
import inboundMessageContentFilterEs from './inboundMessageContentFilter/es.json'
import inboundRateControlEs from './inboundRateControl/es.json'
import inboundRecipientPoliciesEs from './inboundRecipientPolicies/es.json'
import inboundRegionalPoliciesEs from './inboundRegionalPolicies/es.json'
import inboundSenderAuthenticationEs from './inboundSenderAuthentication/es.json'
import inboundSenderPoliciesEs from './inboundSenderPolicies/es.json'
import inboundSenderPolicyEs from './inboundSenderPolicy/es.json'
import inboundSpamScoringEs from './inboundSpamScoring/es.json'
import incidentResponseEs from './incidentResponse/es.json'
import linkedAccountsEs from './linkedAccounts/es.json'
import linkProtectionEs from './linkProtection/es.json'
import logEs from './log/es.json'
import mailServerTestEs from './mailServerTest/es.json'
import outboundAntiVirusEs from './outboundAntiVirus/es.json'
import outboundAttachmentFilterEs from './outboundAttachmentFilter/es.json'
import outboundContentPoliciesEs from './outboundContentPolicies/es.json'
import outboundDlpEs from './outboundDlp/es.json'
import outboundEncryptionEs from './outboundEncryption/es.json'
import outboundIpAddressPoliciesEs from './outboundIpAddressPolicies/es.json'
import outboundMessageContentFilterEs from './outboundMessageContentFilter/es.json'
import outboundPredefinedFiltersEs from './outboundPredefinedFilters/es.json'
import outboundQuarantineInboxEs from './outboundQuarantineInbox/es.json'
import outboundRateControlEs from './outboundRateControl/es.json'
import outboundRecipientPolicyEs from './outboundRecipientPolicy/es.json'
import outboundSenderIpEs from './outboundSenderIp/es.json'
import outboundSenderIpRangesEs from './outboundSenderIpRanges/es.json'
import outboundSenderPolicyEs from './outboundSenderPolicy/es.json'
import outboundTaggingEs from './outboundTagging/es.json'
import outboundTaglineEs from './outboundTagline/es.json'
import quarantineEs from './quarantine/es.json'
import quarantineNotificationEs from './quarantineNotification/es.json'
import recipientListEs from './recipientList/es.json'
import recipientVerificationEs from './recipientVerification/es.json'
import regexEs from './regex/es.json'
import reportsAllDomainsEs from './reportsAllDomains/es.json'
import reportsDomainEs from './reportsDomain/es.json'
import scheduledReportsEs from './scheduledReports/es.json'
import securityAwarenessTrainingEs from './securityAwarenessTraining/es.json'
import selfService1Es from './selfService1/es.json'
import selfService2Es from './selfService2/es.json'
import selfService3Es from './selfService3/es.json'
import selfService4Es from './selfService4/es.json'
import selfService5Es from './selfService5/es.json'
import senderAuthenticationEs from './senderAuthentication/es.json'
import senderNotificationEs from './senderNotification/es.json'
import senderPolicyEs from './senderPolicy/es.json'
import siemEs from './siem/es.json'
import statusEs from './status/es.json'
import statusSeenRecipientsEs from './statusSeenRecipients/es.json'
import syslogIntegrationEs from './syslogIntegration/es.json'
import systemNotificationsEs from './systemNotifications/es.json'
import usersAllowListEs from './usersAllowList/es.json'
import usersBlockListEs from './usersBlockList/es.json'
import usersDefaultPolicyEs from './usersDefaultPolicy/es.json'
import usersEditEs from './usersEdit/es.json'
import usersEmailContinuityEs from './usersEmailContinuity/es.json'
import usersListEs from './usersList/es.json'
import usersQuarantineEs from './usersQuarantine/es.json'

// French help translations
import accountManagementFr from './accountManagement/fr.json'
import adminAccessFr from './adminAccess/fr.json'
import antiSpamFr from './antiSpam/fr.json'
import apiAccessFr from './apiAccess/fr.json'
import atpExemptFr from './atpExempt/fr.json'
import atpLogFr from './atpLog/fr.json'
import auditLogFr from './auditLog/fr.json'
import complianceFr from './compliance/fr.json'
import configureMxRecordsFr from './configureMxRecords/fr.json'
import customBrandingFr from './customBranding/fr.json'
import directoryServicesFr from './directoryServices/fr.json'
import disclaimerFr from './disclaimer/fr.json'
import dkimSigningFr from './dkimSigning/fr.json'
import dnsSettingsFr from './dnsSettings/fr.json'
import domainManagerFr from './domainManager/fr.json'
import domainMigrationFr from './domainMigration/fr.json'
import domainSettingsFr from './domainSettings/fr.json'
import domainVerificationFr from './domainVerification/fr.json'
import emailConfirmationFr from './emailConfirmation/fr.json'
import emailContinuityFr from './emailContinuity/fr.json'
import emailEncryptionFr from './emailEncryption/fr.json'
import endUserLogFr from './endUserLog/fr.json'
import endUserQuarantineNotificationFr from './endUserQuarantineNotification/fr.json'
import endUserSenderPolicyFr from './endUserSenderPolicy/fr.json'
import exemptRecipientsFr from './exemptRecipients/fr.json'
import forensicDataFr from './forensicData/fr.json'
import impersonationProtectionFr from './impersonationProtection/fr.json'
import inboundAntiPhishingFr from './inboundAntiPhishing/fr.json'
import inboundAntiVirusFr from './inboundAntiVirus/fr.json'
import inboundAtpFr from './inboundAtp/fr.json'
import inboundAttachmentFilterFr from './inboundAttachmentFilter/fr.json'
import inboundBulkMailFr from './inboundBulkMail/fr.json'
import inboundContentPoliciesFr from './inboundContentPolicies/fr.json'
import inboundCustomRblsFr from './inboundCustomRbls/fr.json'
import inboundEmailBannersFr from './inboundEmailBanners/fr.json'
import inboundIntentDomainFr from './inboundIntentDomain/fr.json'
import inboundIpAddressPoliciesFr from './inboundIpAddressPolicies/fr.json'
import inboundMachineLearningFr from './inboundMachineLearning/fr.json'
import inboundMessageContentFilterFr from './inboundMessageContentFilter/fr.json'
import inboundRateControlFr from './inboundRateControl/fr.json'
import inboundRecipientPoliciesFr from './inboundRecipientPolicies/fr.json'
import inboundRegionalPoliciesFr from './inboundRegionalPolicies/fr.json'
import inboundSenderAuthenticationFr from './inboundSenderAuthentication/fr.json'
import inboundSenderPoliciesFr from './inboundSenderPolicies/fr.json'
import inboundSenderPolicyFr from './inboundSenderPolicy/fr.json'
import inboundSpamScoringFr from './inboundSpamScoring/fr.json'
import incidentResponseFr from './incidentResponse/fr.json'
import linkedAccountsFr from './linkedAccounts/fr.json'
import linkProtectionFr from './linkProtection/fr.json'
import logFr from './log/fr.json'
import mailServerTestFr from './mailServerTest/fr.json'
import outboundAntiVirusFr from './outboundAntiVirus/fr.json'
import outboundAttachmentFilterFr from './outboundAttachmentFilter/fr.json'
import outboundContentPoliciesFr from './outboundContentPolicies/fr.json'
import outboundDlpFr from './outboundDlp/fr.json'
import outboundEncryptionFr from './outboundEncryption/fr.json'
import outboundIpAddressPoliciesFr from './outboundIpAddressPolicies/fr.json'
import outboundMessageContentFilterFr from './outboundMessageContentFilter/fr.json'
import outboundPredefinedFiltersFr from './outboundPredefinedFilters/fr.json'
import outboundQuarantineInboxFr from './outboundQuarantineInbox/fr.json'
import outboundRateControlFr from './outboundRateControl/fr.json'
import outboundRecipientPolicyFr from './outboundRecipientPolicy/fr.json'
import outboundSenderIpFr from './outboundSenderIp/fr.json'
import outboundSenderIpRangesFr from './outboundSenderIpRanges/fr.json'
import outboundSenderPolicyFr from './outboundSenderPolicy/fr.json'
import outboundTaggingFr from './outboundTagging/fr.json'
import outboundTaglineFr from './outboundTagline/fr.json'
import quarantineFr from './quarantine/fr.json'
import quarantineNotificationFr from './quarantineNotification/fr.json'
import recipientListFr from './recipientList/fr.json'
import recipientVerificationFr from './recipientVerification/fr.json'
import regexFr from './regex/fr.json'
import reportsAllDomainsFr from './reportsAllDomains/fr.json'
import reportsDomainFr from './reportsDomain/fr.json'
import scheduledReportsFr from './scheduledReports/fr.json'
import securityAwarenessTrainingFr from './securityAwarenessTraining/fr.json'
import selfService1Fr from './selfService1/fr.json'
import selfService2Fr from './selfService2/fr.json'
import selfService3Fr from './selfService3/fr.json'
import selfService4Fr from './selfService4/fr.json'
import selfService5Fr from './selfService5/fr.json'
import senderAuthenticationFr from './senderAuthentication/fr.json'
import senderNotificationFr from './senderNotification/fr.json'
import senderPolicyFr from './senderPolicy/fr.json'
import siemFr from './siem/fr.json'
import statusFr from './status/fr.json'
import statusSeenRecipientsFr from './statusSeenRecipients/fr.json'
import syslogIntegrationFr from './syslogIntegration/fr.json'
import systemNotificationsFr from './systemNotifications/fr.json'
import usersAllowListFr from './usersAllowList/fr.json'
import usersBlockListFr from './usersBlockList/fr.json'
import usersDefaultPolicyFr from './usersDefaultPolicy/fr.json'
import usersEditFr from './usersEdit/fr.json'
import usersEmailContinuityFr from './usersEmailContinuity/fr.json'
import usersListFr from './usersList/fr.json'
import usersQuarantineFr from './usersQuarantine/fr.json'

// German help translations
import accountManagementDe from './accountManagement/de.json'
import adminAccessDe from './adminAccess/de.json'
import antiSpamDe from './antiSpam/de.json'
import apiAccessDe from './apiAccess/de.json'
import atpExemptDe from './atpExempt/de.json'
import atpLogDe from './atpLog/de.json'
import auditLogDe from './auditLog/de.json'
import complianceDe from './compliance/de.json'
import configureMxRecordsDe from './configureMxRecords/de.json'
import customBrandingDe from './customBranding/de.json'
import directoryServicesDe from './directoryServices/de.json'
import disclaimerDe from './disclaimer/de.json'
import dkimSigningDe from './dkimSigning/de.json'
import dnsSettingsDe from './dnsSettings/de.json'
import domainManagerDe from './domainManager/de.json'
import domainMigrationDe from './domainMigration/de.json'
import domainSettingsDe from './domainSettings/de.json'
import domainVerificationDe from './domainVerification/de.json'
import emailConfirmationDe from './emailConfirmation/de.json'
import emailContinuityDe from './emailContinuity/de.json'
import emailEncryptionDe from './emailEncryption/de.json'
import endUserLogDe from './endUserLog/de.json'
import endUserQuarantineNotificationDe from './endUserQuarantineNotification/de.json'
import endUserSenderPolicyDe from './endUserSenderPolicy/de.json'
import exemptRecipientsDe from './exemptRecipients/de.json'
import forensicDataDe from './forensicData/de.json'
import impersonationProtectionDe from './impersonationProtection/de.json'
import inboundAntiPhishingDe from './inboundAntiPhishing/de.json'
import inboundAntiVirusDe from './inboundAntiVirus/de.json'
import inboundAtpDe from './inboundAtp/de.json'
import inboundAttachmentFilterDe from './inboundAttachmentFilter/de.json'
import inboundBulkMailDe from './inboundBulkMail/de.json'
import inboundContentPoliciesDe from './inboundContentPolicies/de.json'
import inboundCustomRblsDe from './inboundCustomRbls/de.json'
import inboundEmailBannersDe from './inboundEmailBanners/de.json'
import inboundIntentDomainDe from './inboundIntentDomain/de.json'
import inboundIpAddressPoliciesDe from './inboundIpAddressPolicies/de.json'
import inboundMachineLearningDe from './inboundMachineLearning/de.json'
import inboundMessageContentFilterDe from './inboundMessageContentFilter/de.json'
import inboundRateControlDe from './inboundRateControl/de.json'
import inboundRecipientPoliciesDe from './inboundRecipientPolicies/de.json'
import inboundRegionalPoliciesDe from './inboundRegionalPolicies/de.json'
import inboundSenderAuthenticationDe from './inboundSenderAuthentication/de.json'
import inboundSenderPoliciesDe from './inboundSenderPolicies/de.json'
import inboundSenderPolicyDe from './inboundSenderPolicy/de.json'
import inboundSpamScoringDe from './inboundSpamScoring/de.json'
import incidentResponseDe from './incidentResponse/de.json'
import linkedAccountsDe from './linkedAccounts/de.json'
import linkProtectionDe from './linkProtection/de.json'
import logDe from './log/de.json'
import mailServerTestDe from './mailServerTest/de.json'
import outboundAntiVirusDe from './outboundAntiVirus/de.json'
import outboundAttachmentFilterDe from './outboundAttachmentFilter/de.json'
import outboundContentPoliciesDe from './outboundContentPolicies/de.json'
import outboundDlpDe from './outboundDlp/de.json'
import outboundEncryptionDe from './outboundEncryption/de.json'
import outboundIpAddressPoliciesDe from './outboundIpAddressPolicies/de.json'
import outboundMessageContentFilterDe from './outboundMessageContentFilter/de.json'
import outboundPredefinedFiltersDe from './outboundPredefinedFilters/de.json'
import outboundQuarantineInboxDe from './outboundQuarantineInbox/de.json'
import outboundRateControlDe from './outboundRateControl/de.json'
import outboundRecipientPolicyDe from './outboundRecipientPolicy/de.json'
import outboundSenderIpDe from './outboundSenderIp/de.json'
import outboundSenderIpRangesDe from './outboundSenderIpRanges/de.json'
import outboundSenderPolicyDe from './outboundSenderPolicy/de.json'
import outboundTaggingDe from './outboundTagging/de.json'
import outboundTaglineDe from './outboundTagline/de.json'
import quarantineDe from './quarantine/de.json'
import quarantineNotificationDe from './quarantineNotification/de.json'
import recipientListDe from './recipientList/de.json'
import recipientVerificationDe from './recipientVerification/de.json'
import regexDe from './regex/de.json'
import reportsAllDomainsDe from './reportsAllDomains/de.json'
import reportsDomainDe from './reportsDomain/de.json'
import scheduledReportsDe from './scheduledReports/de.json'
import securityAwarenessTrainingDe from './securityAwarenessTraining/de.json'
import selfService1De from './selfService1/de.json'
import selfService2De from './selfService2/de.json'
import selfService3De from './selfService3/de.json'
import selfService4De from './selfService4/de.json'
import selfService5De from './selfService5/de.json'
import senderAuthenticationDe from './senderAuthentication/de.json'
import senderNotificationDe from './senderNotification/de.json'
import senderPolicyDe from './senderPolicy/de.json'
import siemDe from './siem/de.json'
import statusDe from './status/de.json'
import statusSeenRecipientsDe from './statusSeenRecipients/de.json'
import syslogIntegrationDe from './syslogIntegration/de.json'
import systemNotificationsDe from './systemNotifications/de.json'
import usersAllowListDe from './usersAllowList/de.json'
import usersBlockListDe from './usersBlockList/de.json'
import usersDefaultPolicyDe from './usersDefaultPolicy/de.json'
import usersEditDe from './usersEdit/de.json'
import usersEmailContinuityDe from './usersEmailContinuity/de.json'
import usersListDe from './usersList/de.json'
import usersQuarantineDe from './usersQuarantine/de.json'

// Italian help translations
import accountManagementIt from './accountManagement/it.json'
import adminAccessIt from './adminAccess/it.json'
import antiSpamIt from './antiSpam/it.json'
import apiAccessIt from './apiAccess/it.json'
import atpExemptIt from './atpExempt/it.json'
import atpLogIt from './atpLog/it.json'
import auditLogIt from './auditLog/it.json'
import complianceIt from './compliance/it.json'
import configureMxRecordsIt from './configureMxRecords/it.json'
import customBrandingIt from './customBranding/it.json'
import directoryServicesIt from './directoryServices/it.json'
import disclaimerIt from './disclaimer/it.json'
import dkimSigningIt from './dkimSigning/it.json'
import dnsSettingsIt from './dnsSettings/it.json'
import domainManagerIt from './domainManager/it.json'
import domainMigrationIt from './domainMigration/it.json'
import domainSettingsIt from './domainSettings/it.json'
import domainVerificationIt from './domainVerification/it.json'
import emailConfirmationIt from './emailConfirmation/it.json'
import emailContinuityIt from './emailContinuity/it.json'
import emailEncryptionIt from './emailEncryption/it.json'
import endUserLogIt from './endUserLog/it.json'
import endUserQuarantineNotificationIt from './endUserQuarantineNotification/it.json'
import endUserSenderPolicyIt from './endUserSenderPolicy/it.json'
import exemptRecipientsIt from './exemptRecipients/it.json'
import forensicDataIt from './forensicData/it.json'
import impersonationProtectionIt from './impersonationProtection/it.json'
import inboundAntiPhishingIt from './inboundAntiPhishing/it.json'
import inboundAntiVirusIt from './inboundAntiVirus/it.json'
import inboundAtpIt from './inboundAtp/it.json'
import inboundAttachmentFilterIt from './inboundAttachmentFilter/it.json'
import inboundBulkMailIt from './inboundBulkMail/it.json'
import inboundContentPoliciesIt from './inboundContentPolicies/it.json'
import inboundCustomRblsIt from './inboundCustomRbls/it.json'
import inboundEmailBannersIt from './inboundEmailBanners/it.json'
import inboundIntentDomainIt from './inboundIntentDomain/it.json'
import inboundIpAddressPoliciesIt from './inboundIpAddressPolicies/it.json'
import inboundMachineLearningIt from './inboundMachineLearning/it.json'
import inboundMessageContentFilterIt from './inboundMessageContentFilter/it.json'
import inboundRateControlIt from './inboundRateControl/it.json'
import inboundRecipientPoliciesIt from './inboundRecipientPolicies/it.json'
import inboundRegionalPoliciesIt from './inboundRegionalPolicies/it.json'
import inboundSenderAuthenticationIt from './inboundSenderAuthentication/it.json'
import inboundSenderPoliciesIt from './inboundSenderPolicies/it.json'
import inboundSenderPolicyIt from './inboundSenderPolicy/it.json'
import inboundSpamScoringIt from './inboundSpamScoring/it.json'
import incidentResponseIt from './incidentResponse/it.json'
import linkedAccountsIt from './linkedAccounts/it.json'
import linkProtectionIt from './linkProtection/it.json'
import logIt from './log/it.json'
import mailServerTestIt from './mailServerTest/it.json'
import outboundAntiVirusIt from './outboundAntiVirus/it.json'
import outboundAttachmentFilterIt from './outboundAttachmentFilter/it.json'
import outboundContentPoliciesIt from './outboundContentPolicies/it.json'
import outboundDlpIt from './outboundDlp/it.json'
import outboundEncryptionIt from './outboundEncryption/it.json'
import outboundIpAddressPoliciesIt from './outboundIpAddressPolicies/it.json'
import outboundMessageContentFilterIt from './outboundMessageContentFilter/it.json'
import outboundPredefinedFiltersIt from './outboundPredefinedFilters/it.json'
import outboundQuarantineInboxIt from './outboundQuarantineInbox/it.json'
import outboundRateControlIt from './outboundRateControl/it.json'
import outboundRecipientPolicyIt from './outboundRecipientPolicy/it.json'
import outboundSenderIpIt from './outboundSenderIp/it.json'
import outboundSenderIpRangesIt from './outboundSenderIpRanges/it.json'
import outboundSenderPolicyIt from './outboundSenderPolicy/it.json'
import outboundTaggingIt from './outboundTagging/it.json'
import outboundTaglineIt from './outboundTagline/it.json'
import quarantineIt from './quarantine/it.json'
import quarantineNotificationIt from './quarantineNotification/it.json'
import recipientListIt from './recipientList/it.json'
import recipientVerificationIt from './recipientVerification/it.json'
import regexIt from './regex/it.json'
import reportsAllDomainsIt from './reportsAllDomains/it.json'
import reportsDomainIt from './reportsDomain/it.json'
import scheduledReportsIt from './scheduledReports/it.json'
import securityAwarenessTrainingIt from './securityAwarenessTraining/it.json'
import selfService1It from './selfService1/it.json'
import selfService2It from './selfService2/it.json'
import selfService3It from './selfService3/it.json'
import selfService4It from './selfService4/it.json'
import selfService5It from './selfService5/it.json'
import senderAuthenticationIt from './senderAuthentication/it.json'
import senderNotificationIt from './senderNotification/it.json'
import senderPolicyIt from './senderPolicy/it.json'
import siemIt from './siem/it.json'
import statusIt from './status/it.json'
import statusSeenRecipientsIt from './statusSeenRecipients/it.json'
import syslogIntegrationIt from './syslogIntegration/it.json'
import systemNotificationsIt from './systemNotifications/it.json'
import usersAllowListIt from './usersAllowList/it.json'
import usersBlockListIt from './usersBlockList/it.json'
import usersDefaultPolicyIt from './usersDefaultPolicy/it.json'
import usersEditIt from './usersEdit/it.json'
import usersEmailContinuityIt from './usersEmailContinuity/it.json'
import usersListIt from './usersList/it.json'
import usersQuarantineIt from './usersQuarantine/it.json'

// Dutch help translations
import accountManagementNl from './accountManagement/nl.json'
import adminAccessNl from './adminAccess/nl.json'
import antiSpamNl from './antiSpam/nl.json'
import apiAccessNl from './apiAccess/nl.json'
import atpExemptNl from './atpExempt/nl.json'
import atpLogNl from './atpLog/nl.json'
import auditLogNl from './auditLog/nl.json'
import complianceNl from './compliance/nl.json'
import configureMxRecordsNl from './configureMxRecords/nl.json'
import customBrandingNl from './customBranding/nl.json'
import directoryServicesNl from './directoryServices/nl.json'
import disclaimerNl from './disclaimer/nl.json'
import dkimSigningNl from './dkimSigning/nl.json'
import dnsSettingsNl from './dnsSettings/nl.json'
import domainManagerNl from './domainManager/nl.json'
import domainMigrationNl from './domainMigration/nl.json'
import domainSettingsNl from './domainSettings/nl.json'
import domainVerificationNl from './domainVerification/nl.json'
import emailConfirmationNl from './emailConfirmation/nl.json'
import emailContinuityNl from './emailContinuity/nl.json'
import emailEncryptionNl from './emailEncryption/nl.json'
import endUserLogNl from './endUserLog/nl.json'
import endUserQuarantineNotificationNl from './endUserQuarantineNotification/nl.json'
import endUserSenderPolicyNl from './endUserSenderPolicy/nl.json'
import exemptRecipientsNl from './exemptRecipients/nl.json'
import forensicDataNl from './forensicData/nl.json'
import impersonationProtectionNl from './impersonationProtection/nl.json'
import inboundAntiPhishingNl from './inboundAntiPhishing/nl.json'
import inboundAntiVirusNl from './inboundAntiVirus/nl.json'
import inboundAtpNl from './inboundAtp/nl.json'
import inboundAttachmentFilterNl from './inboundAttachmentFilter/nl.json'
import inboundBulkMailNl from './inboundBulkMail/nl.json'
import inboundContentPoliciesNl from './inboundContentPolicies/nl.json'
import inboundCustomRblsNl from './inboundCustomRbls/nl.json'
import inboundEmailBannersNl from './inboundEmailBanners/nl.json'
import inboundIntentDomainNl from './inboundIntentDomain/nl.json'
import inboundIpAddressPoliciesNl from './inboundIpAddressPolicies/nl.json'
import inboundMachineLearningNl from './inboundMachineLearning/nl.json'
import inboundMessageContentFilterNl from './inboundMessageContentFilter/nl.json'
import inboundRateControlNl from './inboundRateControl/nl.json'
import inboundRecipientPoliciesNl from './inboundRecipientPolicies/nl.json'
import inboundRegionalPoliciesNl from './inboundRegionalPolicies/nl.json'
import inboundSenderAuthenticationNl from './inboundSenderAuthentication/nl.json'
import inboundSenderPoliciesNl from './inboundSenderPolicies/nl.json'
import inboundSenderPolicyNl from './inboundSenderPolicy/nl.json'
import inboundSpamScoringNl from './inboundSpamScoring/nl.json'
import incidentResponseNl from './incidentResponse/nl.json'
import linkedAccountsNl from './linkedAccounts/nl.json'
import linkProtectionNl from './linkProtection/nl.json'
import logNl from './log/nl.json'
import mailServerTestNl from './mailServerTest/nl.json'
import outboundAntiVirusNl from './outboundAntiVirus/nl.json'
import outboundAttachmentFilterNl from './outboundAttachmentFilter/nl.json'
import outboundContentPoliciesNl from './outboundContentPolicies/nl.json'
import outboundDlpNl from './outboundDlp/nl.json'
import outboundEncryptionNl from './outboundEncryption/nl.json'
import outboundIpAddressPoliciesNl from './outboundIpAddressPolicies/nl.json'
import outboundMessageContentFilterNl from './outboundMessageContentFilter/nl.json'
import outboundPredefinedFiltersNl from './outboundPredefinedFilters/nl.json'
import outboundQuarantineInboxNl from './outboundQuarantineInbox/nl.json'
import outboundRateControlNl from './outboundRateControl/nl.json'
import outboundRecipientPolicyNl from './outboundRecipientPolicy/nl.json'
import outboundSenderIpNl from './outboundSenderIp/nl.json'
import outboundSenderIpRangesNl from './outboundSenderIpRanges/nl.json'
import outboundSenderPolicyNl from './outboundSenderPolicy/nl.json'
import outboundTaggingNl from './outboundTagging/nl.json'
import outboundTaglineNl from './outboundTagline/nl.json'
import quarantineNl from './quarantine/nl.json'
import quarantineNotificationNl from './quarantineNotification/nl.json'
import recipientListNl from './recipientList/nl.json'
import recipientVerificationNl from './recipientVerification/nl.json'
import regexNl from './regex/nl.json'
import reportsAllDomainsNl from './reportsAllDomains/nl.json'
import reportsDomainNl from './reportsDomain/nl.json'
import scheduledReportsNl from './scheduledReports/nl.json'
import securityAwarenessTrainingNl from './securityAwarenessTraining/nl.json'
import selfService1Nl from './selfService1/nl.json'
import selfService2Nl from './selfService2/nl.json'
import selfService3Nl from './selfService3/nl.json'
import selfService4Nl from './selfService4/nl.json'
import selfService5Nl from './selfService5/nl.json'
import senderAuthenticationNl from './senderAuthentication/nl.json'
import senderNotificationNl from './senderNotification/nl.json'
import senderPolicyNl from './senderPolicy/nl.json'
import siemNl from './siem/nl.json'
import statusNl from './status/nl.json'
import statusSeenRecipientsNl from './statusSeenRecipients/nl.json'
import syslogIntegrationNl from './syslogIntegration/nl.json'
import systemNotificationsNl from './systemNotifications/nl.json'
import usersAllowListNl from './usersAllowList/nl.json'
import usersBlockListNl from './usersBlockList/nl.json'
import usersDefaultPolicyNl from './usersDefaultPolicy/nl.json'
import usersEditNl from './usersEdit/nl.json'
import usersEmailContinuityNl from './usersEmailContinuity/nl.json'
import usersListNl from './usersList/nl.json'
import usersQuarantineNl from './usersQuarantine/nl.json'

export const helpMessagesEn = {
  ...accountManagementEn,
  ...adminAccessEn,
  ...antiSpamEn,
  ...apiAccessEn,
  ...atpExemptEn,
  ...atpLogEn,
  ...auditLogEn,
  ...complianceEn,
  ...configureMxRecordsEn,
  ...customBrandingEn,
  ...directoryServicesEn,
  ...disclaimerEn,
  ...dkimSigningEn,
  ...dnsSettingsEn,
  ...domainManagerEn,
  ...domainMigrationEn,
  ...domainSettingsEn,
  ...domainVerificationEn,
  ...emailConfirmationEn,
  ...emailContinuityEn,
  ...emailEncryptionEn,
  ...endUserLogEn,
  ...endUserQuarantineNotificationEn,
  ...endUserSenderPolicyEn,
  ...exemptRecipientsEn,
  ...forensicDataEn,
  ...impersonationProtectionEn,
  ...inboundAntiPhishingEn,
  ...inboundAntiVirusEn,
  ...inboundAtpEn,
  ...inboundAttachmentFilterEn,
  ...inboundBulkMailEn,
  ...inboundContentPoliciesEn,
  ...inboundCustomRblsEn,
  ...inboundEmailBannersEn,
  ...inboundIntentDomainEn,
  ...inboundIpAddressPoliciesEn,
  ...inboundMachineLearningEn,
  ...inboundMessageContentFilterEn,
  ...inboundRateControlEn,
  ...inboundRecipientPoliciesEn,
  ...inboundRegionalPoliciesEn,
  ...inboundSenderAuthenticationEn,
  ...inboundSenderPoliciesEn,
  ...inboundSenderPolicyEn,
  ...inboundSpamScoringEn,
  ...incidentResponseEn,
  ...linkedAccountsEn,
  ...linkProtectionEn,
  ...logEn,
  ...mailServerTestEn,
  ...outboundAntiVirusEn,
  ...outboundAttachmentFilterEn,
  ...outboundContentPoliciesEn,
  ...outboundDlpEn,
  ...outboundEncryptionEn,
  ...outboundIpAddressPoliciesEn,
  ...outboundMessageContentFilterEn,
  ...outboundPredefinedFiltersEn,
  ...outboundQuarantineInboxEn,
  ...outboundRateControlEn,
  ...outboundRecipientPolicyEn,
  ...outboundSenderIpEn,
  ...outboundSenderIpRangesEn,
  ...outboundSenderPolicyEn,
  ...outboundTaggingEn,
  ...outboundTaglineEn,
  ...quarantineEn,
  ...quarantineNotificationEn,
  ...recipientListEn,
  ...recipientVerificationEn,
  ...regexEn,
  ...reportsAllDomainsEn,
  ...reportsDomainEn,
  ...scheduledReportsEn,
  ...securityAwarenessTrainingEn,
  ...selfService1En,
  ...selfService2En,
  ...selfService3En,
  ...selfService4En,
  ...selfService5En,
  ...senderAuthenticationEn,
  ...senderNotificationEn,
  ...senderPolicyEn,
  ...siemEn,
  ...statusEn,
  ...statusSeenRecipientsEn,
  ...syslogIntegrationEn,
  ...systemNotificationsEn,
  ...usersAllowListEn,
  ...usersBlockListEn,
  ...usersDefaultPolicyEn,
  ...usersEditEn,
  ...usersEmailContinuityEn,
  ...usersListEn,
  ...usersQuarantineEn
}

export const helpMessagesJa = {
  ...accountManagementJa,
  ...adminAccessJa,
  ...antiSpamJa,
  ...apiAccessJa,
  ...atpExemptJa,
  ...atpLogJa,
  ...auditLogJa,
  ...complianceJa,
  ...configureMxRecordsJa,
  ...customBrandingJa,
  ...directoryServicesJa,
  ...disclaimerJa,
  ...dkimSigningJa,
  ...dnsSettingsJa,
  ...domainManagerJa,
  ...domainMigrationJa,
  ...domainSettingsJa,
  ...domainVerificationJa,
  ...emailConfirmationJa,
  ...emailContinuityJa,
  ...emailEncryptionJa,
  ...endUserLogJa,
  ...endUserQuarantineNotificationJa,
  ...endUserSenderPolicyJa,
  ...exemptRecipientsJa,
  ...forensicDataJa,
  ...impersonationProtectionJa,
  ...inboundAntiPhishingJa,
  ...inboundAntiVirusJa,
  ...inboundAtpJa,
  ...inboundAttachmentFilterJa,
  ...inboundBulkMailJa,
  ...inboundContentPoliciesJa,
  ...inboundCustomRblsJa,
  ...inboundEmailBannersJa,
  ...inboundIntentDomainJa,
  ...inboundIpAddressPoliciesJa,
  ...inboundMachineLearningJa,
  ...inboundMessageContentFilterJa,
  ...inboundRateControlJa,
  ...inboundRecipientPoliciesJa,
  ...inboundRegionalPoliciesJa,
  ...inboundSenderAuthenticationJa,
  ...inboundSenderPoliciesJa,
  ...inboundSenderPolicyJa,
  ...inboundSpamScoringJa,
  ...incidentResponseJa,
  ...linkedAccountsJa,
  ...linkProtectionJa,
  ...logJa,
  ...mailServerTestJa,
  ...outboundAntiVirusJa,
  ...outboundAttachmentFilterJa,
  ...outboundContentPoliciesJa,
  ...outboundDlpJa,
  ...outboundEncryptionJa,
  ...outboundIpAddressPoliciesJa,
  ...outboundMessageContentFilterJa,
  ...outboundPredefinedFiltersJa,
  ...outboundQuarantineInboxJa,
  ...outboundRateControlJa,
  ...outboundRecipientPolicyJa,
  ...outboundSenderIpJa,
  ...outboundSenderIpRangesJa,
  ...outboundSenderPolicyJa,
  ...outboundTaggingJa,
  ...outboundTaglineJa,
  ...quarantineJa,
  ...quarantineNotificationJa,
  ...recipientListJa,
  ...recipientVerificationJa,
  ...regexJa,
  ...reportsAllDomainsJa,
  ...reportsDomainJa,
  ...scheduledReportsJa,
  ...securityAwarenessTrainingJa,
  ...selfService1Ja,
  ...selfService2Ja,
  ...selfService3Ja,
  ...selfService4Ja,
  ...selfService5Ja,
  ...senderAuthenticationJa,
  ...senderNotificationJa,
  ...senderPolicyJa,
  ...siemJa,
  ...statusJa,
  ...statusSeenRecipientsJa,
  ...syslogIntegrationJa,
  ...systemNotificationsJa,
  ...usersAllowListJa,
  ...usersBlockListJa,
  ...usersDefaultPolicyJa,
  ...usersEditJa,
  ...usersEmailContinuityJa,
  ...usersListJa,
  ...usersQuarantineJa
}

export const helpMessagesEs = {
  ...accountManagementEs,
  ...adminAccessEs,
  ...antiSpamEs,
  ...apiAccessEs,
  ...atpExemptEs,
  ...atpLogEs,
  ...auditLogEs,
  ...complianceEs,
  ...configureMxRecordsEs,
  ...customBrandingEs,
  ...directoryServicesEs,
  ...disclaimerEs,
  ...dkimSigningEs,
  ...dnsSettingsEs,
  ...domainManagerEs,
  ...domainMigrationEs,
  ...domainSettingsEs,
  ...domainVerificationEs,
  ...emailConfirmationEs,
  ...emailContinuityEs,
  ...emailEncryptionEs,
  ...endUserLogEs,
  ...endUserQuarantineNotificationEs,
  ...endUserSenderPolicyEs,
  ...exemptRecipientsEs,
  ...forensicDataEs,
  ...impersonationProtectionEs,
  ...inboundAntiPhishingEs,
  ...inboundAntiVirusEs,
  ...inboundAtpEs,
  ...inboundAttachmentFilterEs,
  ...inboundBulkMailEs,
  ...inboundContentPoliciesEs,
  ...inboundCustomRblsEs,
  ...inboundEmailBannersEs,
  ...inboundIntentDomainEs,
  ...inboundIpAddressPoliciesEs,
  ...inboundMachineLearningEs,
  ...inboundMessageContentFilterEs,
  ...inboundRateControlEs,
  ...inboundRecipientPoliciesEs,
  ...inboundRegionalPoliciesEs,
  ...inboundSenderAuthenticationEs,
  ...inboundSenderPoliciesEs,
  ...inboundSenderPolicyEs,
  ...inboundSpamScoringEs,
  ...incidentResponseEs,
  ...linkedAccountsEs,
  ...linkProtectionEs,
  ...logEs,
  ...mailServerTestEs,
  ...outboundAntiVirusEs,
  ...outboundAttachmentFilterEs,
  ...outboundContentPoliciesEs,
  ...outboundDlpEs,
  ...outboundEncryptionEs,
  ...outboundIpAddressPoliciesEs,
  ...outboundMessageContentFilterEs,
  ...outboundPredefinedFiltersEs,
  ...outboundQuarantineInboxEs,
  ...outboundRateControlEs,
  ...outboundRecipientPolicyEs,
  ...outboundSenderIpEs,
  ...outboundSenderIpRangesEs,
  ...outboundSenderPolicyEs,
  ...outboundTaggingEs,
  ...outboundTaglineEs,
  ...quarantineEs,
  ...quarantineNotificationEs,
  ...recipientListEs,
  ...recipientVerificationEs,
  ...regexEs,
  ...reportsAllDomainsEs,
  ...reportsDomainEs,
  ...scheduledReportsEs,
  ...securityAwarenessTrainingEs,
  ...selfService1Es,
  ...selfService2Es,
  ...selfService3Es,
  ...selfService4Es,
  ...selfService5Es,
  ...senderAuthenticationEs,
  ...senderNotificationEs,
  ...senderPolicyEs,
  ...siemEs,
  ...statusEs,
  ...statusSeenRecipientsEs,
  ...syslogIntegrationEs,
  ...systemNotificationsEs,
  ...usersAllowListEs,
  ...usersBlockListEs,
  ...usersDefaultPolicyEs,
  ...usersEditEs,
  ...usersEmailContinuityEs,
  ...usersListEs,
  ...usersQuarantineEs
}

export const helpMessagesFr = {
  ...accountManagementFr,
  ...adminAccessFr,
  ...antiSpamFr,
  ...apiAccessFr,
  ...atpExemptFr,
  ...atpLogFr,
  ...auditLogFr,
  ...complianceFr,
  ...configureMxRecordsFr,
  ...customBrandingFr,
  ...directoryServicesFr,
  ...disclaimerFr,
  ...dkimSigningFr,
  ...dnsSettingsFr,
  ...domainManagerFr,
  ...domainMigrationFr,
  ...domainSettingsFr,
  ...domainVerificationFr,
  ...emailConfirmationFr,
  ...emailContinuityFr,
  ...emailEncryptionFr,
  ...endUserLogFr,
  ...endUserQuarantineNotificationFr,
  ...endUserSenderPolicyFr,
  ...exemptRecipientsFr,
  ...forensicDataFr,
  ...impersonationProtectionFr,
  ...inboundAntiPhishingFr,
  ...inboundAntiVirusFr,
  ...inboundAtpFr,
  ...inboundAttachmentFilterFr,
  ...inboundBulkMailFr,
  ...inboundContentPoliciesFr,
  ...inboundCustomRblsFr,
  ...inboundEmailBannersFr,
  ...inboundIntentDomainFr,
  ...inboundIpAddressPoliciesFr,
  ...inboundMachineLearningFr,
  ...inboundMessageContentFilterFr,
  ...inboundRateControlFr,
  ...inboundRecipientPoliciesFr,
  ...inboundRegionalPoliciesFr,
  ...inboundSenderAuthenticationFr,
  ...inboundSenderPoliciesFr,
  ...inboundSenderPolicyFr,
  ...inboundSpamScoringFr,
  ...incidentResponseFr,
  ...linkedAccountsFr,
  ...linkProtectionFr,
  ...logFr,
  ...mailServerTestFr,
  ...outboundAntiVirusFr,
  ...outboundAttachmentFilterFr,
  ...outboundContentPoliciesFr,
  ...outboundDlpFr,
  ...outboundEncryptionFr,
  ...outboundIpAddressPoliciesFr,
  ...outboundMessageContentFilterFr,
  ...outboundPredefinedFiltersFr,
  ...outboundQuarantineInboxFr,
  ...outboundRateControlFr,
  ...outboundRecipientPolicyFr,
  ...outboundSenderIpFr,
  ...outboundSenderIpRangesFr,
  ...outboundSenderPolicyFr,
  ...outboundTaggingFr,
  ...outboundTaglineFr,
  ...quarantineFr,
  ...quarantineNotificationFr,
  ...recipientListFr,
  ...recipientVerificationFr,
  ...regexFr,
  ...reportsAllDomainsFr,
  ...reportsDomainFr,
  ...scheduledReportsFr,
  ...securityAwarenessTrainingFr,
  ...selfService1Fr,
  ...selfService2Fr,
  ...selfService3Fr,
  ...selfService4Fr,
  ...selfService5Fr,
  ...senderAuthenticationFr,
  ...senderNotificationFr,
  ...senderPolicyFr,
  ...siemFr,
  ...statusFr,
  ...statusSeenRecipientsFr,
  ...syslogIntegrationFr,
  ...systemNotificationsFr,
  ...usersAllowListFr,
  ...usersBlockListFr,
  ...usersDefaultPolicyFr,
  ...usersEditFr,
  ...usersEmailContinuityFr,
  ...usersListFr,
  ...usersQuarantineFr
}

export const helpMessagesDe = {
  ...accountManagementDe,
  ...adminAccessDe,
  ...antiSpamDe,
  ...apiAccessDe,
  ...atpExemptDe,
  ...atpLogDe,
  ...auditLogDe,
  ...complianceDe,
  ...configureMxRecordsDe,
  ...customBrandingDe,
  ...directoryServicesDe,
  ...disclaimerDe,
  ...dkimSigningDe,
  ...dnsSettingsDe,
  ...domainManagerDe,
  ...domainMigrationDe,
  ...domainSettingsDe,
  ...domainVerificationDe,
  ...emailConfirmationDe,
  ...emailContinuityDe,
  ...emailEncryptionDe,
  ...endUserLogDe,
  ...endUserQuarantineNotificationDe,
  ...endUserSenderPolicyDe,
  ...exemptRecipientsDe,
  ...forensicDataDe,
  ...impersonationProtectionDe,
  ...inboundAntiPhishingDe,
  ...inboundAntiVirusDe,
  ...inboundAtpDe,
  ...inboundAttachmentFilterDe,
  ...inboundBulkMailDe,
  ...inboundContentPoliciesDe,
  ...inboundCustomRblsDe,
  ...inboundEmailBannersDe,
  ...inboundIntentDomainDe,
  ...inboundIpAddressPoliciesDe,
  ...inboundMachineLearningDe,
  ...inboundMessageContentFilterDe,
  ...inboundRateControlDe,
  ...inboundRecipientPoliciesDe,
  ...inboundRegionalPoliciesDe,
  ...inboundSenderAuthenticationDe,
  ...inboundSenderPoliciesDe,
  ...inboundSenderPolicyDe,
  ...inboundSpamScoringDe,
  ...incidentResponseDe,
  ...linkedAccountsDe,
  ...linkProtectionDe,
  ...logDe,
  ...mailServerTestDe,
  ...outboundAntiVirusDe,
  ...outboundAttachmentFilterDe,
  ...outboundContentPoliciesDe,
  ...outboundDlpDe,
  ...outboundEncryptionDe,
  ...outboundIpAddressPoliciesDe,
  ...outboundMessageContentFilterDe,
  ...outboundPredefinedFiltersDe,
  ...outboundQuarantineInboxDe,
  ...outboundRateControlDe,
  ...outboundRecipientPolicyDe,
  ...outboundSenderIpDe,
  ...outboundSenderIpRangesDe,
  ...outboundSenderPolicyDe,
  ...outboundTaggingDe,
  ...outboundTaglineDe,
  ...quarantineDe,
  ...quarantineNotificationDe,
  ...recipientListDe,
  ...recipientVerificationDe,
  ...regexDe,
  ...reportsAllDomainsDe,
  ...reportsDomainDe,
  ...scheduledReportsDe,
  ...securityAwarenessTrainingDe,
  ...selfService1De,
  ...selfService2De,
  ...selfService3De,
  ...selfService4De,
  ...selfService5De,
  ...senderAuthenticationDe,
  ...senderNotificationDe,
  ...senderPolicyDe,
  ...siemDe,
  ...statusDe,
  ...statusSeenRecipientsDe,
  ...syslogIntegrationDe,
  ...systemNotificationsDe,
  ...usersAllowListDe,
  ...usersBlockListDe,
  ...usersDefaultPolicyDe,
  ...usersEditDe,
  ...usersEmailContinuityDe,
  ...usersListDe,
  ...usersQuarantineDe
}

export const helpMessagesIt = {
  ...accountManagementIt,
  ...adminAccessIt,
  ...antiSpamIt,
  ...apiAccessIt,
  ...atpExemptIt,
  ...atpLogIt,
  ...auditLogIt,
  ...complianceIt,
  ...configureMxRecordsIt,
  ...customBrandingIt,
  ...directoryServicesIt,
  ...disclaimerIt,
  ...dkimSigningIt,
  ...dnsSettingsIt,
  ...domainManagerIt,
  ...domainMigrationIt,
  ...domainSettingsIt,
  ...domainVerificationIt,
  ...emailConfirmationIt,
  ...emailContinuityIt,
  ...emailEncryptionIt,
  ...endUserLogIt,
  ...endUserQuarantineNotificationIt,
  ...endUserSenderPolicyIt,
  ...exemptRecipientsIt,
  ...forensicDataIt,
  ...impersonationProtectionIt,
  ...inboundAntiPhishingIt,
  ...inboundAntiVirusIt,
  ...inboundAtpIt,
  ...inboundAttachmentFilterIt,
  ...inboundBulkMailIt,
  ...inboundContentPoliciesIt,
  ...inboundCustomRblsIt,
  ...inboundEmailBannersIt,
  ...inboundIntentDomainIt,
  ...inboundIpAddressPoliciesIt,
  ...inboundMachineLearningIt,
  ...inboundMessageContentFilterIt,
  ...inboundRateControlIt,
  ...inboundRecipientPoliciesIt,
  ...inboundRegionalPoliciesIt,
  ...inboundSenderAuthenticationIt,
  ...inboundSenderPoliciesIt,
  ...inboundSenderPolicyIt,
  ...inboundSpamScoringIt,
  ...incidentResponseIt,
  ...linkedAccountsIt,
  ...linkProtectionIt,
  ...logIt,
  ...mailServerTestIt,
  ...outboundAntiVirusIt,
  ...outboundAttachmentFilterIt,
  ...outboundContentPoliciesIt,
  ...outboundDlpIt,
  ...outboundEncryptionIt,
  ...outboundIpAddressPoliciesIt,
  ...outboundMessageContentFilterIt,
  ...outboundPredefinedFiltersIt,
  ...outboundQuarantineInboxIt,
  ...outboundRateControlIt,
  ...outboundRecipientPolicyIt,
  ...outboundSenderIpIt,
  ...outboundSenderIpRangesIt,
  ...outboundSenderPolicyIt,
  ...outboundTaggingIt,
  ...outboundTaglineIt,
  ...quarantineIt,
  ...quarantineNotificationIt,
  ...recipientListIt,
  ...recipientVerificationIt,
  ...regexIt,
  ...reportsAllDomainsIt,
  ...reportsDomainIt,
  ...scheduledReportsIt,
  ...securityAwarenessTrainingIt,
  ...selfService1It,
  ...selfService2It,
  ...selfService3It,
  ...selfService4It,
  ...selfService5It,
  ...senderAuthenticationIt,
  ...senderNotificationIt,
  ...senderPolicyIt,
  ...siemIt,
  ...statusIt,
  ...statusSeenRecipientsIt,
  ...syslogIntegrationIt,
  ...systemNotificationsIt,
  ...usersAllowListIt,
  ...usersBlockListIt,
  ...usersDefaultPolicyIt,
  ...usersEditIt,
  ...usersEmailContinuityIt,
  ...usersListIt,
  ...usersQuarantineIt
}

export const helpMessagesNl = {
  ...accountManagementNl,
  ...adminAccessNl,
  ...antiSpamNl,
  ...apiAccessNl,
  ...atpExemptNl,
  ...atpLogNl,
  ...auditLogNl,
  ...complianceNl,
  ...configureMxRecordsNl,
  ...customBrandingNl,
  ...directoryServicesNl,
  ...disclaimerNl,
  ...dkimSigningNl,
  ...dnsSettingsNl,
  ...domainManagerNl,
  ...domainMigrationNl,
  ...domainSettingsNl,
  ...domainVerificationNl,
  ...emailConfirmationNl,
  ...emailContinuityNl,
  ...emailEncryptionNl,
  ...endUserLogNl,
  ...endUserQuarantineNotificationNl,
  ...endUserSenderPolicyNl,
  ...exemptRecipientsNl,
  ...forensicDataNl,
  ...impersonationProtectionNl,
  ...inboundAntiPhishingNl,
  ...inboundAntiVirusNl,
  ...inboundAtpNl,
  ...inboundAttachmentFilterNl,
  ...inboundBulkMailNl,
  ...inboundContentPoliciesNl,
  ...inboundCustomRblsNl,
  ...inboundEmailBannersNl,
  ...inboundIntentDomainNl,
  ...inboundIpAddressPoliciesNl,
  ...inboundMachineLearningNl,
  ...inboundMessageContentFilterNl,
  ...inboundRateControlNl,
  ...inboundRecipientPoliciesNl,
  ...inboundRegionalPoliciesNl,
  ...inboundSenderAuthenticationNl,
  ...inboundSenderPoliciesNl,
  ...inboundSenderPolicyNl,
  ...inboundSpamScoringNl,
  ...incidentResponseNl,
  ...linkedAccountsNl,
  ...linkProtectionNl,
  ...logNl,
  ...mailServerTestNl,
  ...outboundAntiVirusNl,
  ...outboundAttachmentFilterNl,
  ...outboundContentPoliciesNl,
  ...outboundDlpNl,
  ...outboundEncryptionNl,
  ...outboundIpAddressPoliciesNl,
  ...outboundMessageContentFilterNl,
  ...outboundPredefinedFiltersNl,
  ...outboundQuarantineInboxNl,
  ...outboundRateControlNl,
  ...outboundRecipientPolicyNl,
  ...outboundSenderIpNl,
  ...outboundSenderIpRangesNl,
  ...outboundSenderPolicyNl,
  ...outboundTaggingNl,
  ...outboundTaglineNl,
  ...quarantineNl,
  ...quarantineNotificationNl,
  ...recipientListNl,
  ...recipientVerificationNl,
  ...regexNl,
  ...reportsAllDomainsNl,
  ...reportsDomainNl,
  ...scheduledReportsNl,
  ...securityAwarenessTrainingNl,
  ...selfService1Nl,
  ...selfService2Nl,
  ...selfService3Nl,
  ...selfService4Nl,
  ...selfService5Nl,
  ...senderAuthenticationNl,
  ...senderNotificationNl,
  ...senderPolicyNl,
  ...siemNl,
  ...statusNl,
  ...statusSeenRecipientsNl,
  ...syslogIntegrationNl,
  ...systemNotificationsNl,
  ...usersAllowListNl,
  ...usersBlockListNl,
  ...usersDefaultPolicyNl,
  ...usersEditNl,
  ...usersEmailContinuityNl,
  ...usersListNl,
  ...usersQuarantineNl
}
